export const VENDOR_CONTACT_THEME = {
  enterprise: {
    primary: '#4800FF',
    hover: '#3a00cc',
  },
};

export const VENDOR_DETAIL_FIELDS = [
  { key: 'business_poc_name', label: 'POC Name' },
  { key: 'business_poc_mobile', label: 'POC Mobile No' },
  { key: 'business_email', label: 'Business Email' },
  { key: 'business_address', label: 'Registered Address' },
];

export function downloadContactDetails(vendor, filePrefix = 'contact') {
  if (!vendor) return;
  const lines = [
    `Name: ${vendor.name || '—'}`,
    `GSTIN: ${vendor.legal_gstin_number || '—'}`,
    ...VENDOR_DETAIL_FIELDS.map(({ key, label }) => `${label}: ${vendor[key] || '—'}`),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/plain;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `${(vendor.name || filePrefix).replace(/\s+/g, '-')}-details.txt`;
  anchor.click();
  URL.revokeObjectURL(url);
}

export function buildTelHref(mobile) {
  const digits = String(mobile || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length === 10) return `tel:+91${digits}`;
  return `tel:+${digits}`;
}

export function renderContactNumber(value) {
  if (!value) return '—';
  if (String(value).includes('*')) return value;
  const href = buildTelHref(value);
  if (!href) return value;
  return (
    <a href={href} className="VendorDetails_phoneLink">
      {value}
    </a>
  );
}
